import fetchInterceptImport from 'fetch-intercept';
/** CJS default export under Vite resolves to `{ default: fetchIntercept }`; unwrap for valid element/callable type. */
const fetchIntercept = fetchInterceptImport?.default ?? fetchInterceptImport;
export default fetchIntercept.register({
  request: function(url, config) {
    // Modify the url or config here
    return [url, config];
  },

  requestError: function(error) {
    // Called when an error occured during another 'request' interceptor call
    return Promise.reject(error);
  },

  response: function(response) {
    // Modify the reponse object
    if (response.status === 500) {
      window.location = '/servererror';
    }
    return response;
  },

  responseError: function(error) {
    // Handle an fetch error
    return Promise.reject(error);
  },
});
